module.exports = __webpack_public_path__ + "img/20200508_173500.0ba98fa6.jpg";